<template>
  <div class="modal fade" id="miw-translate-modal" tabindex="-1" role="dialog"
       aria-labelledby="miw-translate-label"
       aria-hidden="true">

    <div class="modal-dialog ">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="miw-translate-label">ترنسلیت</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="d-block">

            <div class="form-row" dir="ltr">
              <textarea v-model="preTranslations" name="" id="" cols="30" rows="10" class="form-control"></textarea>
              <button class="btn btn-primary m-2" @click="setTranslations()">submit</button>
            </div>

            <template v-for="(value,key,index) in flatten(siteTranslations)" :key="index">
              <translate-input :translation-object="siteTranslations" :translation-key="key"/>
            </template>

          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">save</button>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import {mapGetters} from "vuex";
import TranslateInput from "@/components/Translations/TranslateInput";
import {flatten, traverseAndFlatten, isJson} from "@/store/Modules/Site";
import {toast} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification'

export default {
  name: "TranslateModal",
  components: {TranslateInput},
  data() {
    return {
      preTranslations: ''
    }
  },
  methods: {
    traverseAndFlatten,
    flatten,
    setVmodel(translateObject, keys) {
      let item = translateObject;
      keys = keys.split('.')
      keys.forEach(key => {
        item = item[key]
      })
      return item
    },
    setTranslations() {
      if (isJson(this.preTranslations) !== false) {

        let translations = this.flatten(JSON.parse(this.preTranslations))
        Object.entries(translations).forEach(item => {
          const value = item[1]
          const translationItemPath = item[0]
          this.$store.dispatch('Site/setTranslationItem', {value: value, translationItemPath: translationItemPath})
        })

      } else {
        toast('not json', 'not json', 'danger')
      }
    }
  },
  computed: {
    ...mapGetters({
      siteTranslations: "Site/getSiteTranslations",
    })
  },
}
</script>

<style scoped>

</style>